import type { TOC } from '@ember/component/template-only';
import { PrismViewSwitcher } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { RATES_PAGE_MODES } from 'lumen/utils/constants/rate-constants';

interface HotelPricingAssistantPageModeViewSwitcherSignature {
  Args: {
    pageMode: (typeof RATES_PAGE_MODES)[keyof typeof RATES_PAGE_MODES];
    updatePageMode: (targetPageMode: string) => void;
  };
}

const HotelPricingAssistantPageModeViewSwitcher: TOC<HotelPricingAssistantPageModeViewSwitcherSignature> =
  <template>
    <PrismViewSwitcher
      @activeButtonId={{@pageMode}}
      @onSetActiveButtonId={{@updatePageMode}}
      as |ViewSwitcher|
    >
      <ViewSwitcher.button
        @icon="rates-lowest"
        @id={{RATES_PAGE_MODES.PRICING}}
        @label={{t "rates.page_modes.pricing"}}
      />
      <ViewSwitcher.button
        @icon="compare"
        @id={{RATES_PAGE_MODES.RATES}}
        @label={{t "rates.page_modes.rate_comparison"}}
        data-test-id="rates-viewswitcher-rate-comparison-button"
      />
    </PrismViewSwitcher>
  </template>;

export default HotelPricingAssistantPageModeViewSwitcher;
